import { Button, Flex } from "@chakra-ui/react";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { EmailInviteContextDto } from "../../../../autogen/bff-api";
import { useLoggedOutState } from "../../../../common/auth/useLoggedOutState";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { signupAsPersonThunk } from "../../../../common/redux/thunks/auth/signup-as-person-thunk";
import { ConsentCheckboxes, ConsentFieldValues } from "../../../auth/shared/ConsentCheckboxes";
import { OwnerIdentityFields, OwnerIdentityFieldValues } from "../../../auth/shared/OwnerIdentityFields";
import { useSignupError } from "../../../auth/shared/useSignupError";

type FormValues = OwnerIdentityFieldValues & ConsentFieldValues;

interface Props {
  invitationContext: EmailInviteContextDto | null;
}

export const SignupAsPersonForm: React.FC<Props> = ({ invitationContext }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const authState = useLoggedOutState();
  const methods = useForm<FormValues>();

  useSignupError(authState.signupError, methods);

  const signup = async (values: FormValues) => {
    dispatch(
      signupAsPersonThunk({
        loginCredentials: { email: values.email, password: values.password },
        personCredentials: { firstName: values.firstName, lastName: values.lastName },
        invitationContext: invitationContext,
      })
    );
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(signup)}>
        <OwnerIdentityFields />
        <ConsentCheckboxes />
        <Flex mt="10px" justifyContent="end">
          <Button type="submit" colorScheme="teal" isLoading={authState.isSigningUp}>
            {t("Proceed")}
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};
